export const INVITE_ID_KEY = 'inviteId';
